$(window).on("load", function () {
    const body = $("body");
    const toggle = $("#menu-toggle");
    const nav = $("#main-nav");

    toggle.on("click", function () {
        if (toggle.hasClass("open")) {
            toggle.removeClass("open");
            nav.removeClass("toggle-open");
            body.removeClass("fixed");
            nav.slideUp();
            toggle.attr("aria-expanded", "false");
        } else {
            body.addClass("fixed");
            toggle.addClass("open");
            nav.addClass("toggle-open");
            nav.slideDown(200);
            toggle.attr("aria-expanded", "true");
        }
    });

    $(".header-search .icon-search").on("click", function (e) {
        e.preventDefault();
        var $this = $(this);
        var $push = $("#slcgov-header");
        var $form = $("#site-search");

        $this.toggleClass("opensearch");
        $push.toggleClass("opensearch");
        $form.toggleClass("open");
    });

    $(".sub-menu-toggle-btn").on("click", function (e) {
        console.log("submenu click button");
        e.preventDefault();
        var $this = $(this);
        $this.toggleClass("turndial");
        $this.next(".submenu").slideToggle();

        if ($this.attr("aria-expanded") == "true") {
            $this.attr("aria-expanded", "false");
        } else {
            $this.attr("aria-expanded", "true");
        }
    });
});
